import { HttpHeaders } from '@angular/common/http';
import { Injectable, Input, EventEmitter, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MenuItems } from '../model/MenuItems';
import { DataStorageService } from './data-storage.service';
import { CabBookingService } from './cab-booking.service';
import { environment } from 'src/environments/environment';
declare var $: any;
@Injectable()
export class CommonService {
  private FinalArr = {};
  USERID;
  LeadID;
  Name;
  Mobile;
  SalesActivityID;
  MenuList: MenuItems[] = [];
  constructor() {

    this.USERID = localStorage.getItem("UserID");
    // console.log(this.setUserID);
  }

  getHeaders() {
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    })
    return headers;
  }
  toDateString(date: Date): string {
    // console.log(date)
    return (date.getFullYear().toString() + '-'
      + ("0" + (date.getMonth() + 1)).slice(-2) + '-'
      + ("0" + (date.getDate())).slice(-2))
      + 'T' + date.toTimeString().slice(0, 5);
  }


  numberOnly(ev): boolean {
    if (ev.type === "paste" || ev.type === "drop") {
      var textContent = (ev.type === "paste" ? ev.clipboardData : ev.dataTransfer).getData('text');
      return !isNaN(textContent) && textContent.indexOf(".") === -1;
    } else if (ev.type === "keydown") {
      if (ev.ctrlKey || ev.metaKey) {
        return true
      };
      var keysToAllow = [8, 9, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 190];
      return keysToAllow.indexOf(ev.keyCode) > -1;
    } else {
      return true
    }
  }

  noDecimal(ev): boolean {
    if (ev.type === "paste" || ev.type === "drop") {
      var textContent = (ev.type === "paste" ? ev.clipboardData : ev.dataTransfer).getData('text');
      return !isNaN(textContent) && textContent.indexOf(".") === -1;
    } else if (ev.type === "keydown") {
      if (ev.ctrlKey || ev.metaKey) {
        return true
      };
      var keysToAllow = [8, 9, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
      return keysToAllow.indexOf(ev.keyCode) > -1;
    } else {
      return true
    }
  }
  /**
   * New version Methods Block
   * 
   */



  deleteAllCookies() {
    // document.cookie = "username=John Doe";
    var cookies = document.cookie.split(";");
    // console.log(cookies)
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 12 Jan 2022 20:16:00 GMT";
    }
    // console.log(cookies)
  }

  logoutRedirect() {
    localStorage.clear();
//debugger
    //window.location.href = "https://intranet.rspl.net.in/Login.aspx?ReturnUrl=%2f";
     window.location.href = environment.intranetLogin;
     //////////window.location.href = " https://uatintranet.rspl.net.in/Login.aspx?ReturnUrl=%2f";
    //window.location.href = " https://intranet.rspl.net.in/Login.aspx?ReturnUrl=%2f";
    
  }

  disableDate() {
    return false;
  }

  oneHourExtendDate() {
    let dt = new Date();
    dt.setHours(dt.getHours() + 1);
    return dt;
  }

  extendDate() {
    let dt = new Date();
    dt.setHours(dt.getHours());
    return dt;
  }

  convertDateTime(): string {
    // console.log(date)
    var now = new Date();
    var year = now.getFullYear();
    var month: any = now.getMonth() + 1;
    var day: any = now.getDate();
    var hour: any = now.getHours();
    var minute: any = now.getMinutes();
    var second: any = now.getSeconds();
    if (month.toString().length == 1) {
      month = '0' + month;
    }
    if (day.toString().length == 1) {
      day = '0' + day;
    }
    if (hour.toString().length == 1) {
      hour = '0' + hour;
    }
    if (minute.toString().length == 1) {
      minute = '0' + minute;
    }
    if (second.toString().length == 1) {
      second = '0' + second;
    }
    var dateTime = day + '-' + month + '-' + year + ' ' + hour + ':' + minute + ':' + second;
    return dateTime;
  }

  blockSpecialChar(e) {
    var k = e.keyCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 9 || k == 32 || k == 37 || k == 39 || (k >= 48 && k <= 57));
  }

  
  /**
   * 
   * 
   * 
   */
}
